import ApplicationDemoView from './ApplicationDemo.view';
export * from './ApplicationDemo.view';

export const ApplicationDemo = (props) => ApplicationDemoView(props);

export default ApplicationDemo;

